import { nucluesApiGatewayClient} from "./client";

export interface IPendingCardSection {
    iconType: string,
    title: string,
    shortDesc: string,
    CTAText: string,
    sequence: number,
    section_name: string,
    studentsAdded?: number,
    lgaCatID?: string,
    lgaTagNID?: string,
}

export const pendingCardApi = nucluesApiGatewayClient.injectEndpoints({
    endpoints: (builder) => ({
        getStatus: builder.query<{
            success: boolean,
            data: {
                sections: {
                    [key: string]: IPendingCardSection,
                }
                totalSections: number,
                sectionsCompleted: number,
                msg: string,
            }
        }, {schoolId: string, acadId: string, clientApp: string}>({
            query: ({ schoolId, acadId, clientApp }: { schoolId: string, acadId: string, clientApp: string }) => {
                return {
                    url: `/api/gtw/v2/${schoolId}/schoolSetup/sectionDetails`,
                    acadId,
                    headers: {
                        'source': clientApp,
                        'X-Client-App': clientApp,
                    }
                }
            },
        }),
    }),
});
export const { useGetStatusQuery } = pendingCardApi;